import { AppThunkDispatch } from 'src/store/reduxTypes';
import { updatePermissions } from 'src/store/user/actions';

export const customerSubscriptionUpdate = (dispatch: AppThunkDispatch) => {
  dispatch(updatePermissions());
};
